import React, { useEffect } from 'react';
import { initPixel, trackPageView } from './utils/pixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { HackSection } from './components/HackSection';
import { ArsenalSection } from './components/ArsenalSection';
import { FutureSection } from './components/FutureSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { PricingCTA } from './components/PricingCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initPixel('1442163827519971');
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-deep-black text-cream selection:bg-champagne-gold selection:text-deep-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainSection data-id="element-4" />
        <HackSection data-id="element-5" />
        <ArsenalSection data-id="element-6" />
        <FutureSection data-id="element-7" />
        <TargetAudienceSection data-id="element-8" />
        <PricingCTA data-id="element-9" />
        <FAQ data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}